import {
  getChildrenFileList,
  getFileContent,
  removeFile,
} from '@/api/systemlogserv'

export default {
  state: {
    state_SystemLog_GetChildrenFileListResult: null,
    state_SystemLog_GetFileContentResult: null,
    state_SystemLog_RemoveFileResult: null,
  },
  mutations: {
    SET_SYSTEMLOG_GETCHILDRENFILELIST_RESULT: (state, rst) => {
      state.state_SystemLog_GetChildrenFileListResult = rst;
    },
    SET_SYSTEMLOG_GETFILECONTENT_RESULT: (state, rst) => {
      state.state_SystemLog_GetFileContentResult = rst;
    },
    SET_SYSTEMLOG_REMOVEFILE_RESULT: (state, rst) => {
      state.state_SystemLog_RemoveFileResult = rst;
    },
  },
  actions: {
    SystemLogServ_GetChildrenFileList({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getChildrenFileList(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SYSTEMLOG_GETCHILDRENFILELIST_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SYSTEMLOG_GETCHILDRENFILELIST_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SystemLogServ_GetFileContent({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getFileContent(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SYSTEMLOG_GETFILECONTENT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SYSTEMLOG_GETFILECONTENT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    SystemLogServ_RemoveFile({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        removeFile(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_SYSTEMLOG_REMOVEFILE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_SYSTEMLOG_REMOVEFILE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_SystemLog_GetChildrenFileListResult: state => {
      return state.state_SystemLog_GetChildrenFileListResult;
    },
    get_SystemLog_GetFileContentResult: state => {
      return state.state_SystemLog_GetFileContentResult;
    },
    get_SystemLog_RemoveFileResult: state => {
      return state.state_SystemLog_RemoveFileResult;
    },
  }
}